import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppComponent } from '../app.component';
import { environment } from './../../environments/environment'
import { constants } from '../constants'
import { BehaviorSubject } from "rxjs";
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
const url = environment.serviceUrl

declare global {
  interface Window {
    _paq: any[];
  }
}
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  assessment: any = {}
  userId = sessionStorage.getItem('UserId');
  appComponent: AppComponent;
  spinnerCount: number = 0;
  fileUrl: string = environment.fileUrl;
  serviceUrl: string = environment.serviceUrl;
  videoUrl: string = environment.videoUrl;
  public fileObs: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  public userImage: BehaviorSubject<any> = new BehaviorSubject<any>(['', 'data:,', 'null', null].includes(sessionStorage.profileImage) ? "https://i.pinimg.com/736x/89/90/48/899048ab0cc455154006fdb9676964b3.jpg" : sessionStorage.profileImage);
  samvaadUrl: string = environment.SamvaadUrl;
  WebSocket_URL: string = environment.WebSocket_URL;
  paystatus: boolean;
  key = "Dhanu$hLm$@123*";
  totalAmount: any;
  paymentHashkeyobj: any = {};
  timetableData: any = {};
  private wordpressApiUrl = 'https://openunicms.samvaadpro.com/module-7-number-system-conversion/';

  constructor(public http: HttpClient, private route: Router, private toastr: ToastrService) { 
     // Ensure _paq exists
    window._paq = window._paq || [];

    // Init once when service is loaded
    this.initMatomo();
  }


  /////////////////////////////////////spinner/////////////////////////////////////////
  activateSpinner() {
    this.spinnerCount++;
    if (this.spinnerCount == 1) {
      this.appComponent.activateSpinner()

    }
  }
  getWordPressContent(): Observable<any> {
    const url = `${this.wordpressApiUrl}`;
    return this.http.get<any>(url);
  }
  deactivateSpinner() {
    if (!this.spinnerCount) return
    this.spinnerCount--
    if (!this.spinnerCount) this.appComponent.deactivateSpinner();
    if (this.spinnerCount < 0) {
      this.spinnerCount = 0;
      this.appComponent.deactivateSpinner()
    }

  }

  /////////////////////////////////////spinner///////////////////////////////////////

  ///////////////////////////////////post,put and get //////////////////////////////////
  postCall(route, data, isSamvaadURL: boolean = false): Observable<any> {
    let apiUrl = constants[route] || route
    let uri = isSamvaadURL ? this.samvaadUrl + apiUrl : url + apiUrl;
    return this.http.post<any>(uri, data)
  }

    ///////////////////////////////////SMHR post//////////////////////////////////
  smhrPostCall(route, data): Observable<any> {
    let apiUrl = constants[route] || route;
    let uri = environment.smhrServiceUrl + apiUrl;
    return this.http.post<any>(uri, data);
  }

  smhrgetCall(route): Observable<any> {
    let apiUrl = constants[route] || route;
    let uri = environment.smhrServiceUrl + apiUrl;
    return this.http.get(uri);
  }

  reportAPi(data): Observable<any> {
    // let apiUrl = constants[route] || route
    let url = environment.reportUrl;
    return this.http.post<any>(url, data)
  }

  getEditorData(arg0: string, payload: { TENANT_CODE: number; }) {
    let apiUrl = constants[arg0] || arg0
    let finalUrl = url + apiUrl;
    console.log(apiUrl)
    return this.http.post(finalUrl, payload);
  }



  getCall(route, params: string = '', isSamvaadURL: boolean = false): Observable<any> {
    let apiUrl = constants[route] || route
    let uri = isSamvaadURL ? this.samvaadUrl + apiUrl + params : url + apiUrl + params;
    return this.http.get(uri)
  }
  getData(route, params: string = ''): Observable<any> {
    let apiUrl = constants[route] || route
    let uri = this.WebSocket_URL + apiUrl + params;
    return this.http.get(uri)
  }

  getCallWithId(route, id): Observable<any> {
    let apiUrl = constants[route] || route
    let uri = url + apiUrl;
    return this.http.get(uri + '/' + id)
  }
  putCall(route, data): Observable<any> {
    let apiUrl = constants[route] || route
    let uri = url + apiUrl;
    return this.http.put<any>(uri, data)
  }

  getCallWithParams(route, data) {
    let apiUrl = constants[route] || route
    let uri = url + apiUrl;
    return this.http.get(uri, { params: data })
  }
  deleteCall(route, data): Observable<any> {
    let apiUrl = constants[route] || route
    let uri = url + apiUrl;
    return this.http.delete<any>(uri, { params: data })
  }

  samvaadPost(url, payLoad) {
    let uri = this.samvaadUrl + url;
    return this.http.post(uri, payLoad, { headers: this.getSamvaadHeaders() })
  }
  samvaadGet(url) {
    let uri = this.samvaadUrl + url;
    return this.http.get(uri, { headers: this.getSamvaadHeaders() })
  }
  ///////////////////////////////////post,put and get //////////////////////////////////

  menuPermissions(path: string) {
    let payLoad = {
      "tnt_code": localStorage.getItem('TenantCode'),
      "encrypted_role": localStorage.getItem('RoleId'),
      "url": path
    }
    let url = environment.serviceUrl
    this.http.post(url + 'TaskManager/CheckMenuPermissions', payLoad).subscribe((res: any) => {
      if (res.message == false) {
        // this.toastr.error("Access Denied");
        this.route.navigate(['UnauthorizedComponent']);
        localStorage.clear();
        this.deactivateSpinner();

      }
    })
    this.deactivateSpinner();
  }


  getCourseSchedule(data: any) {
    data.UserId = this.userId;
    // data.RoleId = sessionStorage.RoleId
    let apiUrl = constants['GetCourseSchedule'] || 'GetCourseSchedule'
    let uri = url + apiUrl
    return this.http.post(uri, data)

  }

  getCourses() {
    let apiUrl = constants['GetCourses'] || 'GetCourses'
    let uri = url + apiUrl + '/' + this.userId;
    let id = sessionStorage.RoleId
    return this.http.get(uri + '/' + id)
  }

  ///////get cources by admin//////////// http://localhost:50905/GetAdminCourses/68664158/2/51964213/////////////

  getAdminCourses(tnt_code?) {
    let apiUrl = constants['GetAdminCourses'] || 'GetAdminCourses'
    let URL = url + apiUrl + '/' + this.userId;
    let id = sessionStorage.RoleId
    let code = sessionStorage.getItem('TenantCode');
    return this.http.get(URL + '/' + id + '/' + code)
  }
  ///////get cources by admin////////////


  /////////////////GetAdminCourseSchedule///////////////////////////////////////////
  getAdminCourseSchedule(data: any) {
    // data.UserId = this.userId;
    let apiUrl = constants['GetAdminCourseSchedule'] || 'GetAdminCourseSchedule'
    // data.RoleId = sessionStorage.RoleId
    let uri = url + apiUrl
    return this.http.post(uri, data)

  }

  /////////////////////my results///////////////

  getResults() {
    let apiUrl = constants['StudentAssessementResult'] || 'StudentAssessementResult'
    let uri = url + apiUrl + '/' + this.userId;
    return this.http.get(uri)
  }

  /////////////////////my results///////////////

  //////////////////////////get Post Assessments/////////////////////
  getAssessments(data: any) {
    data.UserId = this.userId;
    let uri = url + 'Assessment/ListOfAssessments'
    return this.http.post(uri, data)
  }
  //////////////////////////get Post Assessments/////////////////////

  //////////////////////////Assignments/////////////////////
  getAssignments(data: any) {
    let apiUrl = constants['StudentAssingments'] || 'StudentAssingments'
    data.UserId = this.userId;
    let uri = url + apiUrl
    return this.http.post(uri, data)
  }
  //////////////////////////Assignments/////////////////////

  joinConference(data: any) {
    data.UserId = this.userId;
    let apiUrl = constants['VCDetails'] || 'VCDetails'
    let uri = url + apiUrl;
    return this.http.post(uri, data)
  }

  /////////////////////////////////takeExam//////////////////////     
  takeExam(data: any) {
    // let uri = url + 'GetAssessment'
    let apiUrl = constants['GetAssessment'] || 'GetAssessment'
    let uri = url + apiUrl;
    return this.http.post(uri, data)
  }

  /////////////////////////////////takeExam//////////////////////     

  ///////////////////////////time tracker////////////////////////
  getTimeTracker() {
    let uri = constants['TimeTracker'] ? constants['TimeTracker'] + '/' + this.userId : ['TimeTracker'] + '/' + this.userId;
    return this.http.get(url + uri)
  }
  ///////////////////////////time tracker////////////////////////

  ////////////////////////////get learning material///////////////////////
  getLearningMeterial(data: any) {
    data.UserId = this.userId;
    let uri = url + constants['LearningMeterials'] || 'LearningMeterials'
    return this.http.post(uri, data)
  }

  trackMaterialTime(data: any) {
    data.UserId = parseInt(this.userId);
    let uri = url + constants['TrackMaterialTime'] || 'TrackMaterialTime'
    return this.http.post(uri, data)
  }
  ////////////////////////////get learning material///////////////////////

  /////////////////////////// SetAssessments/////////////////////////////
  setAssessments(data: any) {
    data.UserId = this.userId;
    // let uri = url + 'SetAssessments'
    let uri = url + constants['SetAssessments'] || 'SetAssessments'
    return this.http.post(uri, data)
  }
  /////////////////////////// SetAssessments/////////////////////////////

  ////////////////////////// check answers//////////////////////////////
  checkAnswers(id: any, saId: any) {
    let apiUrl = constants['CheckAnswers'] || 'CheckAnswers'
    let uri = url + apiUrl + '/' + id + '/' + this.userId + '/' + saId
    return this.http.get(uri)
  }

  ////////////////////////// check answers//////////////////////////////

  //////////////////////////get load assignments///////////////////////
  loadAssignments() {
    let apiUrl = constants['LoadAssignments'] || 'LoadAssignments'
    let uri = url + apiUrl;
    let data = {
      TenantCode: sessionStorage.getItem('TenantCode'),
      UserId: this.userId,
      // RoleId: sessionStorage.getItem('RoleId'),
      ROLE_NAME: localStorage.getItem('RoleName')
    }///sessionStorage.getItem('RoleId') ||
    return this.http.post(uri, data)

  }
  //////////////////////////get load assignments///////////////////////

  //////////////////////////  GetAssignmentsById////////////////////////
  getAssignmentsById(id: any) {
    let apiUrl = constants['GetAssignmentsById'] || 'GetAssignmentsById'
    let uri = url + apiUrl + '/' + id
    return this.http.get(uri);
  }
  downloadFile(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }

  //////////////////////////  GetAssignmentsById////////////////////////

  ///////////////////////////LoadAssessmentDropdown//////////////////////

  loadAssessmentDropdown(id: any, s_id: any, c_id: any) {
    let apiUrl = constants['LoadAssessmentDropdown'] || 'LoadAssessmentDropdown'
    let uri = url + apiUrl + '/' + id + '/' + s_id + '/' + c_id;
    return this.http.get(uri)
  }

  ///////////////////////////LoadAssessmentDropdown//////////////////////

  //////////////////////////LoadEvaluateAssignments/////////////////////////
  loadEvaluateAssignments(data: any) {
    let apiUrl = constants['LoadEvaluateAssignments'] || 'LoadEvaluateAssignments'
    let uri = url + apiUrl;
    return this.http.post(uri, data)
  }
  //////////////////////////LoadEvaluateAssignments/////////////////////////


  ////////////////////////SetEvaluateAssignments///////////////////////////////

  setEvaluateAssignments(data: any) {
    let apiUrl = constants['SetEvaluateAssignments'] || 'SetEvaluateAssignments';
    let uri = url + apiUrl;
    data.TenantCode = sessionStorage.getItem('TenantCode');
    data.UserId = this.userId;
    return this.http.post(uri, data)
  }
  ////////////////////////SetEvaluateAssignments///////////////////////////////

  ////////////////////////GetAssignments drop down/////////////////////////////
  getAssignmentsDropDown(id: any) {
    let apiUrl = constants['GetAssignments'] || 'GetAssignments';
    let uri = url + apiUrl + '/' + id;
    return this.http.get(uri)
  }

  ////////////////////////GetAssignments drop down/////////////////////////////

  ///////////////////////SetAssignments/////////////////////////////////////////
  setAssignments(data: any) {
    let apiUrl = constants['SetAssignments'] || 'SetAssignments'
    let uri = url + apiUrl;
    return this.http.post(uri, data)
  }
  ///////////////////////SetAssignments/////////////////////////////////////////

  //////////////////////////////////assessment/////////////////////////////////

  ///////////////////////////////GetAssessmentTime////////////////////////////
  getAssessmentTime(data: any) {
    let apiUrl = constants['GetAssessmentTime'] || 'GetAssessmentTime'
    data.TrainerId = this.userId;
    let uri = url + apiUrl;
    return this.http.post(uri, data)
  }

  //////////////////////////////GetAssessmentUsers/////////////////////////////

  getAssessmentUsers(data: any) {
    let apiUrl = constants['GetAssessmentUsers'] || 'GetAssessmentUsers'
    data.TrainerId = this.userId;
    let uri = url + apiUrl;
    return this.http.post(uri, data)
  }

  /////////////////////////////////GetAssessmentAnswers//////////////////////

  getAssessmentAnswers(data: any) {
    let apiUrl = constants['GetAssessmentAnswers'] || 'GetAssessmentAnswers'
    let uri = url + apiUrl;
    return this.http.post(uri, data)
  }
  /////////////////////////////////SetEvaluateAssessments//////////////////////

  setEvaluateAssessments(data: any) {
    let uri = url + constants['SetEvaluateAssessments'] || 'SetEvaluateAssessments';
    return this.http.post(uri, data)
  }

  ///////////////////////////GetStudentResult/////////////////////////////////

  getStudentResult(s_id: any, a_id: any) {
    let apiUrl = constants['GetStudentResult'] || 'GetStudentResult'
    let uri = url + apiUrl + '/' + s_id + '/' + a_id;
    return this.http.get(uri);
  }

  /////////////////////////SetStudentResult/////////////////////////////////
  setStudentResult(data: any) {
    data.UserId = this.userId;
    data.TenantCode = sessionStorage.getItem('TenantCode')
    let uri = url + constants['SetStudentResult'] || 'SetStudentResult';
    return this.http.post(uri, data)
  }


  //////////////////////////////////assessment/////////////////////////////////

  ///////////////////////////////// cource sessions///////////////////////////
  getCourseScheduleSession(id: any) {
    let apiUrl = constants['GetCourseScheduleSession'] || 'GetCourseScheduleSession'
    let uri = url + apiUrl + '/' + id;
    return this.http.get(uri)
  }

  setCourseScheduleSessions(data: any) {
    let apiUrl = constants['SetCourseScheduleSessions'] || 'SetCourseScheduleSessions'

    let uri = url + apiUrl;
    return this.http.post(uri, data);
  }

  ///////////////////////////////// cource sessions///////////////////////////
  getSamvaadHeaders() {
    const headers = new HttpHeaders()
    headers.append('Authorization', sessionStorage.getItem('stoken'));
    return headers;
  }

   //tracker for actions
  private initMatomo() {
    const u = "//metrics.ouk.ac.ke/analytics/";
    window._paq.push(["setTrackerUrl", u + "matomo.php"]);
    window._paq.push(["setSiteId", "8"]);

    const d = document;
    const g = d.createElement("script");
    const s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = u + "matomo.js";
    s.parentNode.insertBefore(g, s);
  }

  trackPageView(title?: string) {
    if (title) {
      window._paq.push(["setDocumentTitle", title]);
    }
    window._paq.push(["trackPageView"]);
  }

  trackEvent(category: string, action: string, name?: string, value?: number) {
    const event: any[] = ["trackEvent", category, action];
    if (name) event.push(name);
    if (value !== undefined) event.push(value);
    window._paq.push(event);
  }
  async decryptAesGcm(
    base64: string,
    keyStr: string,
    useHashing = false,
  ): Promise<string> {
    // const normalizedBase64 = base64.replace(/_/g, "/");
    const normalizedBase64 = this.normalizeBase64(base64);
    const data = Uint8Array.from(atob(normalizedBase64), (c) =>
      c.charCodeAt(0),
    );
    // const data = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const iv = data.slice(0, 12);
    const tag = data.slice(data.length - 16);
    const cipherText = data.slice(12, data.length - 16);

    let keyBytes: Uint8Array;
    if (useHashing) {
      const md5 = await crypto.subtle.digest(
        "MD5",
        new TextEncoder().encode(keyStr),
      );
      const md5Array = new Uint8Array(md5);
      keyBytes = new Uint8Array(32);
      keyBytes.set(md5Array, 0);
      keyBytes.set(md5Array, 16);
    } else {
      const raw = new TextEncoder().encode(keyStr.padEnd(32, "0"));
      keyBytes = raw.slice(0, 32);
    }
    const keyBuffer =
      keyBytes.buffer instanceof ArrayBuffer
        ? keyBytes.buffer
        : new ArrayBuffer(keyBytes.length);
    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      keyBuffer,
      { name: "AES-GCM" },
      false,
      ["decrypt"],
    );

    const combined = new Uint8Array(cipherText.length + tag.length);
    combined.set(cipherText);
    combined.set(tag, cipherText.length);

    try {
      const decrypted = await crypto.subtle.decrypt(
        { name: "AES-GCM", iv },
        cryptoKey,
        combined,
      );
      return new TextDecoder().decode(decrypted);
    } catch (err) {
      console.error("Decryption failed:", err);
      throw new Error("Invalid decryption");
    }
  }
  normalizeBase64(base64: string): string {
    // Replace URL-safe characters
    let normalized = base64.replace(/-/g, "+").replace(/_/g, "/");

    // Add padding if missing
    const padLength = (4 - (normalized.length % 4)) % 4;
    if (padLength > 0) {
      normalized += "=".repeat(padLength);
    }

    return normalized;
  }
  async encryptAesGcm(
    plainText: string,
    keyStr: string,
    useHashing = false,
  ): Promise<string> {
    const iv = crypto.getRandomValues(new Uint8Array(12)); // 12-byte IV (GCM standard)

    let keyBytes: Uint8Array;

    if (useHashing) {
      const md5 = await crypto.subtle.digest(
        "MD5",
        new TextEncoder().encode(keyStr),
      );
      const md5Array = new Uint8Array(md5);
      keyBytes = new Uint8Array(32);
      keyBytes.set(md5Array, 0);
      keyBytes.set(md5Array, 16);
    } else {
      const raw = new TextEncoder().encode(keyStr.padEnd(32, "0"));
      keyBytes = raw.slice(0, 32);
    }

    // Ensure we pass an ArrayBuffer (avoid SharedArrayBuffer typing issues)
    const keyBuffer = new ArrayBuffer(keyBytes.length);
    new Uint8Array(keyBuffer).set(keyBytes);
    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      keyBuffer,
      { name: "AES-GCM" },
      false,
      ["encrypt"],
    );

    const encryptedBuffer = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      cryptoKey,
      new TextEncoder().encode(plainText),
    );

    const encryptedArray = new Uint8Array(encryptedBuffer);

    // Split cipherText and authTag (last 16 bytes)
    const cipherText = encryptedArray.slice(0, encryptedArray.length - 16);
    const tag = encryptedArray.slice(encryptedArray.length - 16);

    // Combine IV + cipherText + tag
    const combined = new Uint8Array(iv.length + cipherText.length + tag.length);
    combined.set(iv, 0);
    combined.set(cipherText, iv.length);
    combined.set(tag, iv.length + cipherText.length);

    // Convert to Base64
    const base64 = btoa(String.fromCharCode(...combined));

    // URL-safe Base64
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
}
//--skipTests=true